//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules() {
  // No routing rules
}

export const states = {
  conversations: StateFactory({
    url: '/conversations',
    template: componentNameToTemplate('conversationsPage'),
    data: {
      title: 'Conversations',
      navGroup: NavGroup.HOME,
      hasAccess: () => false, // PD-303678 Remove Stale 'Conversation' Feature Code
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.conversations',
        () => import('app/conversations/conversations.app'),
      ),
    },
  }),
};
